export default __webpack_public_path__ + "static/media/Beard_7_C4.22e6c187.svg";